export default {"src":"/_next/static/media/prl.42cccb91.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};